export enum DigitalSignagesTypes {
/*    CustomContent = "Custom Content",*/
/*    FileUpload = "File Upload",*/
    LastSocialEvents = "Last 4 Social Events",
    UpcomingEvents = "Upcoming Events",
    YouTubeVideo = "YouTube Video",
    ContentCreator = "Content Creator",
    Birthdays = "Birthdays",
    EventImages = "Event Images",
    LastWeeksEvents = "Last Week's Events"
}